import styled from 'styled-components';

export const StyledGuardianModalOpenButton = styled.div`
   align-self: flex-start;
   min-width: 215px;
`;
StyledGuardianModalOpenButton.displayName = 'StyledGuardianModalOpenButton';
